(() => {
  const bookingButtonSelector = '.cowlendar-section .book-button';
  const modalSelector = '.cowlendar-modal';
  const enhancedAttribute = 'data-northport-keyboard-ready';
  let bookingOpener = null;
  let modalWasVisible = false;
  let syncFrame = null;

  const setAttribute = (element, name, value) => {
    if (element?.getAttribute(name) !== value) element?.setAttribute(name, value);
  };

  const isModalVisible = (modal) => {
    if (!modal) return false;
    const style = window.getComputedStyle(modal);
    return style.display !== 'none' && style.visibility !== 'hidden';
  };

  const enhanceBookingButton = (button) => {
    if (button.hasAttribute(enhancedAttribute)) return;

    setAttribute(button, enhancedAttribute, 'true');
    setAttribute(button, 'role', 'button');
    setAttribute(button, 'tabindex', '0');
    setAttribute(button, 'aria-label', 'Book Rock Polishing Class');
    button.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;

      event.preventDefault();
      bookingOpener = button;
      button.click();
    });
    button.addEventListener('click', () => {
      bookingOpener = button;
    });
  };

  const enhanceModal = (modal) => {
    const frame = modal?.querySelector('iframe');
    const visible = Boolean(frame) && isModalVisible(modal);

    if (modal) {
      setAttribute(modal, 'role', 'dialog');
      setAttribute(modal, 'aria-modal', 'true');
      setAttribute(modal, 'aria-label', 'Book Rock Polishing Class');
    }

    if (frame) {
      setAttribute(frame, 'title', 'Choose a Rock Polishing Class time');
      setAttribute(frame, 'tabindex', '0');
    }

    if (visible && !modalWasVisible && frame) {
      window.requestAnimationFrame(() => frame.focus());
    }

    if (!visible && modalWasVisible && bookingOpener?.isConnected) {
      bookingOpener.focus();
    }

    modalWasVisible = visible;
  };

  const enhanceInlineWidgets = () => {
    document.querySelectorAll('.northport-booking-inline__widget iframe').forEach((frame) => {
      setAttribute(frame, 'title', 'Choose a Rock Polishing Class time');
    });
  };

  const syncBookingInterface = () => {
    document.querySelectorAll(bookingButtonSelector).forEach(enhanceBookingButton);
    enhanceModal(document.querySelector(modalSelector));
    enhanceInlineWidgets();
  };

  const scheduleSync = () => {
    if (syncFrame) return;
    syncFrame = window.requestAnimationFrame(() => {
      syncFrame = null;
      syncBookingInterface();
    });
  };

  const observer = new MutationObserver(scheduleSync);
  observer.observe(document.documentElement, {
    attributes: true,
    childList: true,
    subtree: true,
  });
  syncBookingInterface();
})();
